import { prefixObjectValues } from '../../../utils';

const form = {
  issuingStateCode: 'issuing-state',
  issuingAgency: 'issuing-agency',
  licenseTitle: 'license-title',
  licenseNumber: 'license-num',
  licenseNotes: 'licenseNotes',
  issueDate: 'issueDate',
  expiryDate: 'expiryDate',
  activeFlag: 'activeFlag',
  submitBtn: 'submit-btn',
  cancelBtn: 'cancel-btn',
  title: 'title',
};

export default prefixObjectValues(form, 'account-licenses-cds-form');
